import { ShipUserConfig } from './ship-user-config.model';

export class ShipConfig extends ShipUserConfig {
  requireEEI = false;
  highValueCommodity = false;
  shipDate: Date | string = new Date();
  showAdditionalShipmentInfo = true;
  showB13 = false;
  showCommodities = false;
  showEEI = false;
  showExportInformation = false;
  showMRN = false;
  showNAFTA = false;
  showNoB13Required = false;
  showBrokerSelect = false;
}
